import { useState, useEffect } from 'react';
import { SidebarMenu } from 'components';
import { IonContent, IonPage } from "@ionic/react";
import EditOptionForm from 'components/categoriaModal/CategoriaModal';
import EditGondolaForm from 'components/categoriaModal/GondolaModal';
import NewCategoriaModal from 'components/categoriaModal/NewCategoriaModal';
import EditPromoForm from 'components/categoriaModal/PromoModal';
import { getOptionsService } from 'services/category.service';
import { useAppSelector } from "hooks";
import { updateOptionsService } from 'services/category.service';
import { updateGondolaPromotionsService } from 'services/category.service';
import { InformativeModal } from 'components';

export default function AdminCat() {
    const { token } = useAppSelector(state => state.user);
    const [categories, setCategories] = useState<any[]>([]);
    const [gondolaAndCold, setGondolaAndCold] = useState<any[]>([]);
    const [promotions, setPromotions] = useState<any[]>([]);
    const [activeTab, setActiveTab] = useState<'categories' | 'gondolaAndCold' | 'promotions'>('categories');

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedGondolaAndCold, setSelectedGondolaAndCold] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);

    const [informativeModalProps, setInformativeModalProps] = useState<{
        type: 'success' | 'warning' | 'informative';
        title?: string;
        text?: string;
    } | null>(null);

    const acceptSuccessfulMessageHandler = () => {
        setInformativeModalProps(null);
    };

    const fetchCategories = async () => {
        if (!token) {
            //console.error("UID no disponible");
            return;
        }
        const fetchedCategories = await getOptionsService(token);
        //console.log("Datos obtenidos del servicio:", fetchedCategories);
        if (fetchedCategories) {
            const { options, gondolaandcold, promotions } = fetchedCategories;

            setCategories([...options || []]);
            setGondolaAndCold([...gondolaandcold || []]);
            setPromotions([...promotions || []]);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, [token]);

    const handleEditClick = (item: any, type: 'categories' | 'gondolaAndCold' | 'promotions') => {
        switch (type) {
            case 'categories':
                setSelectedOption(item);
                setIsModalOpen(true);
                break;
            case 'gondolaAndCold':
                setSelectedGondolaAndCold(item);
                setIsModalOpen(true);
                break;
            case 'promotions':
                setSelectedOption(item);
                setIsModalOpen(true);
                break;
            default:
                //console.error('Tipo desconocido:', type);
        }
    };

    const handleSave = async (updatedOption: any) => {
        try {
            if (!token) {
                //console.error("UID no disponible");
                return;
            }

            const response = await updateOptionsService(token, {
                id: updatedOption.id,
                enabled: updatedOption.enabled,
                name: updatedOption.name,
                requirements: updatedOption.requirements,
                rolsCanAcces: updatedOption.rolsCanAccess,
            });

            if (response && response.status === 200) {
                const updatedCategories = categories.map((category) =>
                    category.id === updatedOption.id ? updatedOption : category
                );
                //console.log('Actualizando informativeModalProps...');
                setInformativeModalProps({
                    type: 'success',
                    title: 'La información ha sido actualizada éxitosamente',
                });
                setCategories(updatedCategories);
                //console.log('Categoría actualizada:', updatedCategories);
            } else {
                // setInformativeModalProps({
                //     type: 'warning',
                //     title: 'Error al actualizar la categoría',
                //     text: 'Por favor, intente nuevamente.',
                // });
                //console.error('Error al actualizar la categoría:', response);
            }
        } catch (error) {
            //console.error('Error en el servicio de actualización:', error);
            // setInformativeModalProps({
            //     type: 'warning',
            //     title: 'Error en el servicio de actualización',
            //     text: 'Ocurrió un error inesperado. Por favor, intente nuevamente.',
            // });
        } finally {
            setIsModalOpen(false); // Cierra el modal
            fetchCategories(); // Refresca la lista de categorías
        }
    };

    const handleSaveGondola = async (updatedOption: any) => {
        //console.log("Datos de la góndola updatedOption:", updatedOption);

        try {
            if (!token) {
                //console.error("UID no disponible");
                return;
            }
            //console.log("uid de la cuenta", uid);
            

            const response = await updateGondolaPromotionsService(token, { name: updatedOption.name, id: updatedOption.id, typeCategory: "gondolaandcold", icon: updatedOption.icon, position: updatedOption.position, enabled: updatedOption.enabled });

            if (response && response.status === 200) {
                const updatedGondolaAndCold = await getOptionsService(token);
                if (updatedGondolaAndCold) {
                    const { gondolaandcold, promotions } = updatedGondolaAndCold;
                    setGondolaAndCold(gondolaandcold || []);
                    setPromotions(promotions || []);
                    //console.log("sera que esta actualizado?", gondolaandcold);
                }
            } else {
                //console.error('Error al actualizar la góndola:', response);
            }
        } catch (error) {
            //console.error('Error en el servicio de actualización:', error);
        } finally {
            setIsModalOpen(false); // Cierra el modal
        }
    }

    const handleSavePromotions = async (updatedOption: any) => {
        console.log("Datos de la góndola updatedOption:", updatedOption);

        try {
            if (!token) {
                return;
            }

            const response = await updateGondolaPromotionsService(token, { name: updatedOption.name, id: updatedOption.id, typeCategory: "promotions", icon: updatedOption.icon, position: updatedOption.position, enabled: updatedOption.enabled });

            if (response && response.status === 200) {
                const updatedGondolaAndCold = await getOptionsService(token);
                if (updatedGondolaAndCold) {
                    const { gondolaandcold, promotions } = updatedGondolaAndCold;
                    setGondolaAndCold(gondolaandcold || []);
                    setPromotions(promotions || []);
                    console.log("sera que esta actualizado?", gondolaandcold);
                }
            } else {
                console.error('Error al actualizar la góndola:', response);
            }
        } catch (error) {
            console.error('Error en el servicio de actualización:', error);
        } finally {
            setIsModalOpen(false); // Cierra el modal
        }
    }


    //console.log("categorias", categories);

    return (
        <IonPage>
            <IonContent>
                <div className='w-full h-screen grid grid-cols-12'>
                    <div className="col-span-2 border-r-2 border-solid border-light">
                        <SidebarMenu pageName="benchmarks_report" />
                    </div>
                    <div className="w-full h-full flex flex-col col-span-10 overflow-y-scroll">
                        <div className="w-full flex justify-between border-b-2 border-tertiary px-4 py-3">

                            <div className="flex gap-4">
                                <button
                                    className={`text-lg font-bold px-4 py-2 rounded-md ${activeTab === 'categories' ? 'bg-primary text-white' : 'bg-light text-primary'}`}
                                    onClick={() => setActiveTab('categories')}
                                >
                                    Configuraciones
                                </button>
                                <button
                                    className={`text-lg font-bold px-4 py-2 rounded-md ${activeTab === 'gondolaAndCold' ? 'bg-primary text-white' : 'bg-light text-primary'}`}
                                    onClick={() => setActiveTab('gondolaAndCold')}
                                >
                                    Góndola y Frío
                                </button>
                                <button
                                    className={`text-lg font-bold px-4 py-2 rounded-md ${activeTab === 'promotions' ? 'bg-primary text-white' : 'bg-light text-primary'}`}
                                    onClick={() => setActiveTab('promotions')}
                                >
                                    Promociones
                                </button>
                            </div>
                            {
                                (activeTab === 'gondolaAndCold' || activeTab === 'promotions') && (
                                    <button
                                        id='CreateNewCategoryButton'
                                        className="text-primary font-bold text-lg bg-primary text-white px-4 py-2 rounded-md  transition-all duration-200"
                                        onClick={() => setIsNewModalOpen(true)}
                                    >
                                        Crear Nueva
                                    </button>
                                )
                            }
                        </div>
                        <div id="main-section" className=" overflow-y-scroll grid grid-cols-2 gap-4  py-4">
                            {
                                activeTab === 'categories' && categories
                                .filter(category => category.name !== 'Inventario')
                                .map((category) => (
                                    <section key={category.id} className="flex flex-col items-center justify-center px-3">
                                        <div className="h-full w-full">
                                            <div className="bg-white h-full px-6 py-4 flex flex-col flex-grow items-center justify-between gap-4 rounded-xl text-center account-information-card">
                                                <div className='flex flex-row justify-between w-full'>
                                                    {category.name}
                                                    {category.enabled ? (
                                                        <div className="flex items-center gap-1">
                                                            <span className='activeStatus'></span>
                                                            <span className='text-[green]'>Activa</span>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-1">
                                                            <span className='disableStatus'></span>
                                                            <span className='text-[red]'>Inactiva</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="flex justify-end w-full">
                                                    <button onClick={() => handleEditClick(category, 'categories')} className='bg-tertiary text-primary px-4 py-2 rounded-md hover:bg-primary transition-all duration-200 hover:text-white'>
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                ))
                            }
                            {
                                activeTab === 'gondolaAndCold' && gondolaAndCold.map((item) => (
                                    <section key={item.id} className="flex flex-col items-center justify-center px-3">
                                        <div className="h-full w-full">
                                            <div className="bg-white h-full px-6 py-4 flex flex-col flex-grow items-center justify-between gap-4 rounded-xl text-center account-information-card">
                                                <div className='flex justify-between w-full'>
                                                    <div className='flex justify-between w-full'>
                                                        {item.name}
                                                        {item.enabled ? (
                                                            <div className="flex items-center gap-1">
                                                                <span className='activeStatus'></span>
                                                                <span className='text-[green]'>Activa</span>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center gap-1">
                                                                <span className='disableStatus'></span>
                                                                <span className='text-[red]'>Inactiva</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='flex justify-center w-full'>
                                                    <img src={item.icon} alt={item.id} className='w-28 h-28' />
                                                </div>
                                                <div className="flex justify-between w-full">
                                                    <p>posicionamiento: {item.position}</p>
                                                    <button onClick={() => handleEditClick(item, 'gondolaAndCold')} className='bg-tertiary text-primary px-4 py-2 rounded-md hover:bg-primary transition-all duration-200 hover:text-white'>
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                ))
                            }
                            {
                                activeTab === 'promotions' && promotions.map((item) => (
                                    <section key={item.id} className="flex flex-col items-center justify-center px-3">
                                        <div className="h-full w-full">
                                            <div className="bg-white h-full px-6 py-4 flex flex-col flex-grow items-center justify-between gap-4 rounded-xl text-center account-information-card">
                                                <div className='flex justify-between w-full'>
                                                    {item.name}
                                                    {item.enabled ? (
                                                        <div className="flex items-center gap-1">
                                                            <span className='activeStatus'></span>
                                                            <span className='text-[green]'>Activa</span>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-1">
                                                            <span className='disableStatus'></span>
                                                            <span className='text-[red]'>Inactiva</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='flex justify-center w-full'>
                                                    <img src={item.icon} alt={item.id} className='w-28 h-28' />
                                                </div>
                                                <div className="flex justify-between w-full">
                                                    <p>posicionamiento: {item.position}</p>
                                                    <button onClick={() => handleEditClick(item, 'promotions')} className='bg-tertiary text-primary px-4 py-2 rounded-md hover:bg-primary transition-all duration-200 hover:text-white'>
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                ))
                            }


                        </div>
                    </div>
                </div>
                {isModalOpen && selectedOption && activeTab === 'categories' && (
                    <EditOptionForm
                        option={selectedOption}
                        onSave={handleSave}
                        onClose={() => setIsModalOpen(false)}
                        availableCategories={categories}
                    />
                )}
                {isModalOpen && selectedGondolaAndCold && activeTab === 'gondolaAndCold' && (
                    <EditGondolaForm
                        option={selectedGondolaAndCold}
                        onSave={handleSaveGondola}
                        onClose={() => setIsModalOpen(false)}
                    />
                )}
                {isModalOpen && selectedOption && activeTab === 'promotions' && (
                    <EditPromoForm
                        option={selectedOption}
                        onSave={handleSavePromotions}
                        onClose={() => setIsModalOpen(false)}
                    />
                )}
                {isNewModalOpen && activeTab === 'gondolaAndCold' && token && (
                    <NewCategoriaModal
                        uid={token}
                        type="Góndola y frío"
                        onClose={() => setIsNewModalOpen(false)}
                        onCategoryCreated={fetchCategories}
                    />
                )}
                {isNewModalOpen && activeTab === 'promotions' && token && (
                    <NewCategoriaModal
                        uid={token}
                        type="Promociones"
                        onClose={() => setIsNewModalOpen(false)}
                        onCategoryCreated={fetchCategories}
                    />
                )}
                {/* Modal de alerta */}
                {informativeModalProps && (

                    <InformativeModal
                        type={informativeModalProps.type}
                        title={informativeModalProps.title}
                        text={informativeModalProps.text}
                        acceptClickHandler={acceptSuccessfulMessageHandler}
                    />
                )}
            </IonContent>
        </IonPage>
    );
}
